import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useMemo } from 'react';
import { useParams, useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import Title from '../../../components/Title';
import StoreList from '../../../components/StoreList';
import { filterStores } from '../../../store/slices/storesSlice';
import { currentLang } from '../../../../../utils/lang';
import { routePaths } from '../../../router/paths';
import { useGetResellersQuery } from '../../../store/services/resellers';
import { setDocumentTitle, setMetaDescription } from '../../../../../utils/meta';
import routesMetaData from '../../../router/routes-meta-data';
import { RouteName } from '../../../router/route-names';
const ResellerStores = () => {
    const { t } = useTranslation();
    const urlParameters = useParams();
    const currentLocale = currentLang();
    const navigate = useNavigate();
    const { data: resellers, error, isLoading: isResellersPending } = useGetResellersQuery('');
    const resellerSlug = (urlParameters[Object.keys(urlParameters)[0]] || '')
        .replace('-veikali', '')
        .replace('-mesta', '');
    const dispatch = useDispatch();
    const reseller = useMemo(() => {
        return isResellersPending || error ? null : resellers.find(reseller => reseller.slug === resellerSlug);
    }, [isResellersPending, error, resellers]);
    useEffect(() => {
        if (reseller) {
            dispatch(filterStores({ reseller: reseller.id }));
            // Update page meta with reseller information
            const routeMetaData = routesMetaData[RouteName.ResellerStores];
            if (routeMetaData) {
                setDocumentTitle(t(routeMetaData.title, { reseller: reseller.name }));
                setMetaDescription(t(routeMetaData.description, { reseller: reseller.name }));
            }
        }
    }, [reseller]);
    useEffect(() => {
        if ((!isResellersPending && !reseller) || error) {
            navigate(routePaths.AllStores[currentLocale], {
                replace: true,
            });
        }
    }, [reseller, isResellersPending, error]);
    useEffect(() => {
        return () => {
            dispatch(filterStores({}));
        };
    }, []);
    return (_jsxs("div", { children: [isResellersPending && (_jsx("div", { className: "position-absolute absolute-center mb-5", children: _jsx("div", { className: "spinner-border spinner-border-lg", role: "status", children: _jsx("span", { className: "sr-only", children: t('store_locator.loading') }) }) })), !isResellersPending && (_jsx(StoreList, { headerComponent: _jsx(Title, { title: t('store_locator.stores.reseller.title', { reseller: reseller && reseller.name }), viewInMap: true }) }))] }));
};
export default ResellerStores;
